import { c as _c } from "react/compiler-runtime";
import { Icon } from '@udemy-v2/icons';
import { BlockList } from '@udemy-v2/react-core-components';
import { ShowMore } from '@udemy-v2/react-reveal-components';
import classNames from 'classnames';
import React, { useEffect, useRef, useState } from 'react';
import { useI18n } from '@udemy-v2/i18n';
import styles from './what-you-will-learn.module.scss';
interface WhatYouWillLearnProps {
  objectives: string[];
  summaryLimit?: number;
  titleTypography?: 'ud-heading-lg' | 'ud-heading-xl';
  listLayoutClassName?: string;
}

/**
 * WhatYouWillLearn component displays a list of learning objectives with a show more/less functionality
 * @param {WhatYouWillLearnProps} props - The component props
 */
export function WhatYouWillLearn(t0) {
  const $ = _c(35);
  const {
    objectives: t1,
    summaryLimit: t2,
    titleTypography: t3,
    listLayoutClassName: t4
  } = t0;
  let t5;
  if ($[0] !== t1) {
    t5 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  const objectives = t5;
  const summaryLimit = t2 === undefined ? 10 : t2;
  const titleTypography = t3 === undefined ? "ud-heading-xl" : t3;
  const listLayoutClassName = t4 === undefined ? styles["objectives-list-two-column-layout"] : t4;
  const [isShowingMore, setIsShowingMore] = useState(false);
  const [isAnyObjectiveTruncated, setIsAnyObjectiveTruncated] = useState(false);
  let t6;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {};
    $[2] = t6;
  } else {
    t6 = $[2];
  }
  const objectivesRefs = useRef(t6);
  const {
    gettext
  } = useI18n();
  let t7;
  let t8;
  if ($[3] !== objectives) {
    t7 = () => {
      const isTruncated = objectives.some(objective => {
        const itemRef = objectivesRefs.current[objective];
        return itemRef && itemRef.scrollHeight > itemRef.clientHeight;
      });
      setIsAnyObjectiveTruncated(isTruncated);
    };
    t8 = [objectives];
    $[3] = objectives;
    $[4] = t7;
    $[5] = t8;
  } else {
    t7 = $[4];
    t8 = $[5];
  }
  useEffect(t7, t8);
  let t9;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = () => {
      setIsShowingMore(_temp);
    };
    $[6] = t9;
  } else {
    t9 = $[6];
  }
  const handleShowMoreToggle = t9;
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  if ($[7] !== gettext || $[8] !== isAnyObjectiveTruncated || $[9] !== isShowingMore || $[10] !== listLayoutClassName || $[11] !== objectives || $[12] !== summaryLimit || $[13] !== titleTypography) {
    t14 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const setRef = id => ref => {
        objectivesRefs.current[id] = ref;
      };
      const renderObjectives = () => {
        const objectiveItemClassName = !isShowingMore ? styles["objective-item"] : undefined;
        return <BlockList size="small" padding="tight" className={classNames(styles["objectives-list"], listLayoutClassName)}>{objectives.map(objective_0 => <BlockList.Item data-purpose="objective" key={objective_0} icon={<Icon glyph="tick" label={false} />}><span className={objectiveItemClassName} ref={setRef(objective_0)}>{objective_0}</span></BlockList.Item>)}</BlockList>;
      };
      if (!objectives.length) {
        t14 = null;
        break bb0;
      }
      const hiddenObjectivesCount = objectives.length - summaryLimit;
      if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
        t13 = <span className="in-page-offset-anchor" id="what-you-will-learn" />;
        t10 = classNames("component-margin", styles["what-you-will-learn"]);
        $[19] = t10;
        $[20] = t13;
      } else {
        t10 = $[19];
        t13 = $[20];
      }
      let t15;
      if ($[21] !== titleTypography) {
        t15 = classNames(titleTypography, styles.title);
        $[21] = titleTypography;
        $[22] = t15;
      } else {
        t15 = $[22];
      }
      let t16;
      if ($[23] !== gettext) {
        t16 = gettext("What you'll learn");
        $[23] = gettext;
        $[24] = t16;
      } else {
        t16 = $[24];
      }
      if ($[25] !== t15 || $[26] !== t16) {
        t11 = <h2 className={t15}>{t16}</h2>;
        $[25] = t15;
        $[26] = t16;
        $[27] = t11;
      } else {
        t11 = $[27];
      }
      t12 = hiddenObjectivesCount > 0 || isAnyObjectiveTruncated ? <ShowMore className={styles["content-spacing"]} collapsedHeight={228} withGradient={true} onToggle={handleShowMoreToggle}>{renderObjectives()}</ShowMore> : <div className={styles["content-spacing"]}>{renderObjectives()}</div>;
    }
    $[7] = gettext;
    $[8] = isAnyObjectiveTruncated;
    $[9] = isShowingMore;
    $[10] = listLayoutClassName;
    $[11] = objectives;
    $[12] = summaryLimit;
    $[13] = titleTypography;
    $[14] = t10;
    $[15] = t11;
    $[16] = t12;
    $[17] = t13;
    $[18] = t14;
  } else {
    t10 = $[14];
    t11 = $[15];
    t12 = $[16];
    t13 = $[17];
    t14 = $[18];
  }
  if (t14 !== Symbol.for("react.early_return_sentinel")) {
    return t14;
  }
  let t15;
  if ($[28] !== t10 || $[29] !== t11 || $[30] !== t12) {
    t15 = <div className={t10}>{t11}{t12}</div>;
    $[28] = t10;
    $[29] = t11;
    $[30] = t12;
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== t13 || $[33] !== t15) {
    t16 = <>{t13}{t15}</>;
    $[32] = t13;
    $[33] = t15;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  return t16;
}
function _temp(prev) {
  return !prev;
}